"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUDFValue = exports.withUDFs = exports.UDFConsumer = exports.UDFProvider = exports.UDFContext = void 0;
/* eslint-disable sort-imports-es6-autofix/sort-imports-es6 */
const AppContext_1 = require("../AppContext");
const languages_1 = require("../../languages");
const react_query_1 = require("react-query");
const core_1 = require("../core");
const ZAlert_1 = require("../../components/ZAlert/ZAlert");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const cacheTimes_1 = require("../cacheTimes");
const apis_1 = require("../../apis");
const useWhyDidYouUpdate_1 = require("../useWhyDidYouUpdate");
const errors_1 = require("../../errors/errors");
const queryConfig = {
    suspense: true,
    staleTime: cacheTimes_1.CacheTimes.OneHour,
    refetchAllOnWindowFocus: false
};
exports.UDFContext = react_1.default.createContext({});
exports.UDFProvider = (props) => {
    const { apiClient: client } = react_1.default.useContext(AppContext_1.AppContext);
    const apiClient = apis_1.useApiClientWithGroupCorrelationId(client);
    const { issueAlert, dismissAlert } = ZAlert_1.useAlerts();
    useWhyDidYouUpdate_1.useWhyDidYouUpdate("UDFProvider", props);
    const getUDFs = react_1.default.useCallback(() => {
        const alert = issueAlert({ type: "info", message: "LoadingUDFs" });
        return apiClient
            .get("UserDefinedFields/GetUserDefinedFieldsAndLists")
            .then(r => {
            if (r && r.data && r.data.d) {
                return r.data.d.results;
            }
            else {
                issueAlert({
                    type: "error",
                    header: "Error",
                    message: "CouldNotFetchUDFs"
                });
                // eslint-disable-next-line no-console
                return Promise.reject(r);
            }
        })
            .catch(error => {
            errors_1.displayAndLogErrorWithMessage(error, "CouldNotFetchUDFs", issueAlert);
            return Promise.resolve({
                UserDefinedFields: [],
                UserDefinedLists: []
            });
        })
            .finally(() => alert && dismissAlert(alert));
    }, [apiClient, dismissAlert, issueAlert]);
    const { data } = react_query_1.useQuery("UDFs", getUDFs, queryConfig);
    return (react_1.default.createElement(exports.UDFContext.Provider, { value: data }, props.children));
};
exports.UDFConsumer = exports.UDFContext.Consumer;
exports.withUDFs = (Component) => (react_1.default.createElement(exports.UDFProvider, null,
    react_1.default.createElement(Component, null)));
const Link = styled_components_1.default.a `
   color: ${props => props.href ? props.theme["app-link-color"] : "inherit"} !important;
   :hover {
      color: ${props => props.href ? props.theme["hover-color"] : "inherit"} !important;
   }
   :active {
      color: ${props => props.href ? props.theme["active-color"] : "inherit"} !important;
   }
   cursor: pointer;
`;
exports.getUDFValue = ({ data, localeId, languageId, udf, value, formatLength = "short" }) => {
    if (udf.Type == "STRING" || udf.Type == "FLOAT" || udf.Type == "INT") {
        return react_1.default.createElement(core_1.FormattedValue, { value: value });
    }
    else if (udf.Type == "ENUM") {
        let udl = data.UserDefinedLists.find((e) => e.Id == udf.UserDefinedListId);
        if (udl && udl.Values) {
            let udlv = udl.Values.find((e) => `${e.Id}` == value);
            return udlv && udlv.Value;
        }
        return null;
    }
    else if (udf.Type == "DATE") {
        return (value && (react_1.default.createElement(core_1.FormattedValue, { value: value, format: formatLength === "long" ? core_1.longDateFormat : core_1.shortDateFormat })));
    }
    else if (udf.Type == "DATETIME") {
        return (value && (react_1.default.createElement(core_1.FormattedValue, { value: value, format: formatLength === "long"
                ? core_1.longDateTimeFormat
                : core_1.shortDateTimeFormat })));
    }
    else if (udf.Type == "TIME") {
        return (value && (react_1.default.createElement(core_1.FormattedValue, { value: value, format: formatLength === "long" ? core_1.longTimeFormat : core_1.shortTimeFormat })));
    }
    else if (udf.Type == "CHECKBOX") {
        return value && value.toLowerCase() == "true"
            ? languages_1.ll({ key: "True", languageId })
            : languages_1.ll({ key: "False", languageId });
    }
    else if (udf.Type == "TEXTAREA") {
        return (value && (react_1.default.createElement("pre", { style: {
                margin: 0,
                fontFamily: "inherit",
                whiteSpace: "normal"
            } }, value)));
    }
    else if (udf.Type == "URL") {
        const [text, link] = `${value}`.split("|");
        return value ? (react_1.default.createElement(Link, { href: link, target: "_blank" }, text ? text : link || "---")) : ("---");
    }
    else {
        return null;
    }
};
//# sourceMappingURL=UserDefinedFields.js.map